<template>
  <div class="footer-action">
    <b-col v-if="backAction">
      <b-button class="btn-cancel btn-width" @click="$emit('routePath')">
        {{ backText }}</b-button
      >
    </b-col>

    <b-col v-else>
      <router-link v-if="routePath" :to="routePath">
        <b-button variant="outline-primary-color" class="btn-width">
          {{ backText }}
        </b-button>
      </router-link>
      <slot name="left" />
    </b-col>

    <b-col class="d-flex justify-content-end" v-if="!hideSubmit">
      <b-button
        variant="outline-primary-color"
        class="mr-3"
        v-if="textCustom"
        @click="$emit('customAction')"
        >{{ textCustom }}</b-button
      >
      <b-button class="btn-primary-color btn-width" @click="$emit('submit')">
        {{ saveText || "บันทึก" }}
      </b-button>
    </b-col>
  </div>
</template>

<script>
export default {
  props: {
    hideSubmit: {
      required: false,
      default: false,
      type: Boolean,
    },
    backAction: {
      required: false,
      type: Boolean,
      default: false,
    },
    routePath: {
      required: false,
    },
    textCustom: {
      required: false,
      type: String,
    },
    saveText: {
      required: false,
      type: String,
    },
    backText: {
      required: false,
      default: "ยกเลิก",
    },
  },
  created() {},
  destroyed() {},
  methods: {},
};
</script>

<style>
@media (min-width: 200px) and (max-width: 414px) {
  .footer-action {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
.footer-action {
  box-shadow: 0px 5px 0px black, 0px 5px 10px black;

  z-index: 100;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px;
  background: #fff;
  display: flex;
  flex-direction: row;
}

.btn-width {
  width: 125px !important;
}
</style>
